// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__OBL1I","addWidgetButton":"Header_addWidgetButton__3GoD-","dashboardTabs":"Header_dashboardTabs__1PXtn","active":"Header_active__3UYf5"};